import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { requestFeatureActivation, resetFeatureActivation } from '../actions/license'

function FeatureBlockedScreen({ featureName, featureLabel, title, description, loading, sent, error, requestFeatureActivation, resetFeatureActivation }) {
  // Reset state when this screen unmounts so a second view starts fresh
  useEffect(() => {
    return () => { resetFeatureActivation() }
  }, [])

  function handleRequest() {
    if (loading || sent) return
    requestFeatureActivation(featureLabel || featureName)
  }

  return (
    <div className="feature-blocked-screen">
      <div className="feature-blocked-card">
        {/* header */}
        <div className="feature-blocked-card-header">
          <div className="feature-blocked-icon-wrap">
            <i className="fas fa-lock feature-blocked-icon"></i>
          </div>
          <div className="feature-blocked-badge">
            <i className="fas fa-circle"></i> No disponible
          </div>
        </div>

        {/* body */}
        <div className="feature-blocked-card-body">
          <h2>{title || 'Funcionalidad no activada'}</h2>
          <p className="feature-blocked-desc">
            {description || <>
              Esta funcionalidad no está activa en tu cuenta.<br />
              Amplía tu plan para desbloquear el acceso.
            </>}
          </p>

          <div className="feature-blocked-divider"></div>

          {sent ? (
            <div className="feature-blocked-sent">
              <div className="feature-blocked-sent-icon">
                <i className="fas fa-check"></i>
              </div>
              <div className="feature-blocked-contact-text">
                <strong>¡Solicitud enviada!</strong>
                <span>Nos pondremos en contacto contigo pronto</span>
              </div>
            </div>
          ) : (
            <button
              className="feature-blocked-contact feature-blocked-contact-btn"
              onClick={handleRequest}
              disabled={loading}
              type="button"
            >
              <div className="feature-blocked-contact-icon">
                {loading
                  ? <i className="fas fa-spinner fa-spin"></i>
                  : <i className="fas fa-headset"></i>
                }
              </div>
              <div className="feature-blocked-contact-text">
                <strong>¿Quieres activarla?</strong>
                <span>
                  {loading
                    ? 'Enviando solicitud…'
                    : 'Contacta con nosotros para más información'
                  }
                </span>
              </div>
              {!loading && (
                <i className="fas fa-chevron-right feature-blocked-chevron"></i>
              )}
            </button>
          )}

          {error && (
            <p className="feature-blocked-error">
              <i className="fas fa-exclamation-circle mr-1"></i>
              Error al enviar la solicitud. Inténtalo de nuevo.
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  loading: state.license.featureLoading,
  sent:    state.license.featureSent,
  error:   state.license.featureError,
})

const mapDispatchToProps = dispatch => ({
  requestFeatureActivation: bindActionCreators(requestFeatureActivation, dispatch),
  resetFeatureActivation:   bindActionCreators(resetFeatureActivation, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(FeatureBlockedScreen)
